import { connect } from 'react-redux';
import * as actions from '../../actions.js';
import { getDomainState } from '../../selectors.js';
import { Messages } from './messages.js';

export default connect(getDomainState, actions)(Messages);
